export default __webpack_public_path__ + "35a1c2418a8d18ccfb8512db8a243462.jpg";